<template>
    <div class="file-uploader input-like">
        <input :id="(id) ? id : fieldId" type="file"
               @change="drop" @focus="focus" @blur="blur" @dragover="focus" @dragenter="focus" @dragleave="blur" @dragend="blur" @drop="drop"
               :required="required" :data-parsley-required-message="(requiredMessage) ? requiredMessage : false" :accept="(accept) ? accept : false"
        />
        <svg-icon id="paperclip" class="attach-icon" :class="{visible: selected.filename}"></svg-icon>
        <div class="label" :class="{visible: selected.filename}">{{ selected.filename }} ({{ sizeNormalised }}{{ sizeUnit}})</div>
        <svg-icon id="edit" class="select-icon"></svg-icon>
    </div>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
    
    props: {
        
		accept: {
			type:		String,
			default:	null,
		},
        
        id: {
            type:       String,
        },
        
		required: {
			type:		Boolean,
			default:	false,
		},
		
		requiredMessage: {
			type:		String,
			default:	null,
		},
        
    },
    
    data() {
		return {
			focused:			false,
			
			selected: {
				file:			null,
				filename:		null,
				extension:		null,
				size:			null,
			},
			
			current:			null,
        };
    },
    
    computed: {
		
		fieldId() {
			return 'file-upload-' + this.uid;
		},
        
		sizeNormalised() {
			if ( this.selected.size ) {
				var size = this.selected.size;
				
				while ( size > 1024 ) {
					size = Math.round(size / 1024);
				}
				
				return Math.round(size * 100) / 100;
			}
			
			return 0;
		},
		
		sizeUnit() {
			var units = ['b', 'kb', 'mb', 'gb', 'tb'];
			var idx = 0;
			
			if ( this.selected.size ) {
				var size = this.selected.size;
				
				while ( size > 1024 ) {
					size = Math.round(size / 1024);
					idx++;
				}
			}
			
			return units[idx];
		},
		
		uid() {
			return this._uid;
		},
		
    },
    
    watch: {
		
		current(now, was) {
			this.$emit('input', (this.current) ? this.current : null);
		},
        
    },
    
    
    
    methods: {
		
		/**
		 * Clear our currently selected upload.
		 *
		 * @param Event e
		 */
		clearUpload() {
			this.current = null;
			 
			this.selected.file = null;
			this.selected.filename = null;
			this.selected.extension = null;
			this.selected.size = null;
			this.$emit('file-cleared', this.selected);
		},
		
		/**
		 * Uploader has gained focus either by direct click or drag over.
		 *
		 * @param Event e
		 */
		focus(e) {
			this.focused = true;
		},
		
		/**
		 * Uploader has lost focus.
		 *
		 * @param Event e
		 */
		blur(e) {
			this.focused = false;
		},
		
		/**
		 * File dropped or uploader changed.
		 *
		 * @param Event e
		 */
		drop(e) {
			// No longer focused
			this.focused = false;
			
			// Work out what we actually targetted
			var files = (e.target) ? e.target.files : e.files;
			
			// Read the file data
			var extension = files[0].name.match(/\.([a-z0-9A-Z]+)$/);
			
			if ( extension && extension.length ) {
				extension = extension[1].toLowerCase();
			} else {
				extension = null;
			}
			
			this.selected.file = files[0];
			this.selected.filename = files[0].name;
			this.selected.size = files[0].size;
            this.selected.extension = extension;
			this.current = {name: e.target.name, value: files[0], filename: files[0].name};
			
			this.$emit('file-selected', this.selected);
		},
        
    },
    
};
</script>